import Popup from 'src/Components/Popup'
import Input from 'src/Components/Form/Input'
import style from './style.module.scss'

interface Props {
  handleNewExperiment: (e: React.FormEvent<HTMLFormElement>) => void,
  setNewExperimentPopup: (value: boolean) => void,
}
export const ExperimentPopup = ({ handleNewExperiment, setNewExperimentPopup }: Props) => {


  return (
    <Popup className={style.new_experiment} title="Add new experiment" closePopup={() => setNewExperimentPopup(false)}>
      <form onSubmit={handleNewExperiment}>
        <Input name="name" label="Name" />
        <button className="btn" type="submit">
          Add
        </button>
      </form>
    </Popup>
  )
}
